/**
 * Loading
 */

const $ = window.jQuery;

$('html').on('click', '.filters-toggle', (event) => {
  $('.filters').slideToggle();
});
